import type { LinkEmbedBlock } from '@/payload-types'
import { LinkEmbedClient } from './Component.client'
import { getOgData } from './og'

interface OpenGraphData {
  title?: string
  description?: string
  image?: string
  siteName?: string
  url?: string
}

async function fetchOpenGraph(url: string): Promise<OpenGraphData | null> {
  try {
    return await getOgData(url)
  } catch (error) {
    console.error('Error fetching OpenGraph data:', error)
    return null
  }
}

type Props = LinkEmbedBlock & {
  className?: string
}

export async function LinkEmbed(props: Props) {
  const { url } = props

  let og: OpenGraphData | null = null

  if (url) {
    og = await fetchOpenGraph(url)
  }

  return <LinkEmbedClient {...props} og={og} />
}
